import axios from '../../utils/axiosConfig';
import { Contexture } from './Contexture';

const BASE_URL = `${process.env.REACT_APP_LAMBDA_API_URL}/contexture/content`;

export class Content {
  static async getDocument(documentId, params) {
    try {
      const profileId = params?.profileId;
      const response = await axios.get(`${BASE_URL}/doc/${documentId}`, {
        headers: Contexture.getHeaders(profileId),
        params,
        responseType: 'blob',
      });

      return response.data;
    } catch (err) {
      throw err;
    }
  }

  static async getDocumentFromRepository(repositoryId, documentId, params) {
    try {
      const profileId = params?.profileId;
      const response = await axios.get(
        `${BASE_URL}/doc/${repositoryId}/${documentId}`,
        {
          headers: Contexture.getHeaders(profileId),
          params,
          responseType: 'blob',
        }
      );

      return response.data;
    } catch (err) {
      throw err;
    }
  }

  static async getDocumentMetadata(documentId, params) {
    try {
      const profileId = params?.profileId;
      const response = await axios.get(`${BASE_URL}/metadata/${documentId}`, {
        headers: Contexture.getHeaders(profileId),
        params,
      });

      return response.data;
    } catch (err) {
      throw err;
    }
  }

  static async getDocumentPage(documentKey, params) {
    try {
      const profileId = params?.profileId;
      const response = await axios.get(`${BASE_URL}/doc_page/${documentKey}`, {
        headers: Contexture.getHeaders(profileId),
        params,
        responseType: 'blob',
      });

      return response.data;
    } catch (err) {
      throw err;
    }
  }

  static async getDocumentPageFromRepository(repositoryId, documentId, params) {
    try {
      const profileId = params?.profileId;
      const response = await axios.get(
        `${BASE_URL}/doc_page/${repositoryId}/${documentId}`,
        {
          headers: Contexture.getHeaders(profileId),
          params,
          responseType: 'blob',
        }
      );

      return response.data;
    } catch (err) {
      throw err;
    }
  }

  static async upload(data, params) {
    try {
      const profileId = params?.profileId;
      const response = await axios.post(`${BASE_URL}/upload`, data, {
        headers: {
          ...Contexture.getHeaders(profileId),
          'Content-Type': 'application/json',
        },
        params,
      });

      return response.data;
    } catch (err) {
      throw err;
    }
  }
}
